<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span class="card-head">Facebook Post Insights</span>
      <span class="pull-right">
        <el-select v-model="facebookPage" size="mini">
          <el-option
            v-for="page in facebookPages"
            :key="page.id"
            :label="page.handle"
            :value="page.id"
          />
        </el-select>
      </span>
      <span class="pull-right">
        <el-input placeholder="Search post..."  size="mini"  v-model="searchTerm" @change="onChangeSearch">
          <el-button slot="append" icon="el-icon-search" @click="onChangeSearch"></el-button>
        </el-input>
      </span>

    </div>
    <div class="content">
      <div v-if="isLoading" class="insights-container">
        <loader message="Loading Post Insights" shadow="none"/>
      </div>
      <div v-else>
        <div class="post-insight" v-for="postInsight of getPostInsights" :key="postInsight.post_id">
          <div class="text-center post-content">{{ postInsight.message.text }}</div>
          <div class="insights-container">
            <div class="square">
              <span class="insight-item">
                <post-insight-item
                  :title="'Impression'"
                  :description="'The number of times your Pages post entered a persons screen.\
                      Posts include statuses, photos, links, videos and more.'"
                  :value="getInsightValue(postInsight, 'impressions.total')"
                ></post-insight-item>
              </span>
            </div>
            <div class="square">
            <span class="insight-item">
              <post-insight-item
                :title="'Engaged users'"
                :description="'The number of unique people who engaged in certain ways with your Page post,\
                      for example by commenting on, liking, sharing, or clicking upon particular elements of the post.'"
                :value="getInsightValue(postInsight, 'engagements.post_engaged_users')"
              ></post-insight-item>
            </span>
            </div>
            <div class="square">
            <span class="insight-item">
              <post-insight-item
                :title="'Engaged fans'"
                :description="'The number of people who have liked your Page and clicked anywhere in your posts.'"
                :value="getInsightValue(postInsight, 'engagements.post_engaged_fan')"
              ></post-insight-item>
            </span>
            </div>
            <div class="square">
            <span class="insight-item">
              <post-insight-item
                :title="'Engaged clicks'"
                :description="'The number of clicks anywhere in your post on News Feed from the user that matched\
                      the audience targeting on it.'"
                :value="getInsightValue(postInsight, 'engagements.post_clicks')"
              ></post-insight-item>
            </span>
            </div>
            <div class="square">
            <span class="insight-item">
              <post-reactions class="text-center" :reaction="postInsight.reactions"></post-reactions>
            </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-pagination
      class="text-center paginate"
      background
      layout="prev, pager, next"
      :page-size="1"
      :total="pages"
      @current-change="onChangePage"
    ></el-pagination>
  </el-card>
</template>

<script>
import { Emoji } from 'emoji-mart-vue';
import Loader from '@/components/common/Loader';
import PostInsightItem from '@/components/social/facebook/PostInsightItem';
import PostReactions from '@/components/social/facebook/PostReactions';

export default {
  name: 'PostInsights',

  props: {
    postInsights: {
      type: Array,
      default: () => [],
    },
    facebookPages: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    pages: {
      type: Number,
      default: 0,
    },
    selectedPage: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    searchTerm: '',
  }),
  computed: {
    getPostInsights() {
      if (!this.postInsights || !this.postInsights.length) return [];
      return this.postInsights;
    },
    facebookPage: {
      get() {
        return this.selectedPage;
      },
      set(value) {
        this.$emit('onSelectedPageChange', value);
      },
    },
  },
  methods: {
    onChangePage(page) {
      this.$emit('changePage', page);
    },

    getInsightValue(insight, chain) {
      return chain.split('.').reduce((acc, val) => (acc ? acc[val] : undefined), insight);
    },
    onChangeSearch() {
      this.$emit('onChangeSerachTerm', this.searchTerm);
    },
  },

  components: {
    PostReactions,
    PostInsightItem,
    Emoji,
    Loader,
  },
};
</script>

<style lang="scss" scoped>
$my-text-color: #676a6c;

.card-head {
  font-size: 1.3em;
  color: $my-text-color;
}

.post-content {
  color: darken($my-text-color, 10%);
  font-weight: 600;
  padding: 13px;
}

.post-insight {
  border: 1px solid #e9e9e9;
  box-shadow: 1px 1px 5px 0 #ddd;
  margin: 5px auto;
}

.insights-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.insight-item {
  display: inline-block;
  margin: 5px auto;
  text-align: justify;
}
.square {
  min-width: 120px;
  height: 100px;
  margin-bottom: 13px !important;
  border: 1px solid #e9e9e9;
  margin: 5px auto;
  border-radius: 3px;
  text-align: center;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}
</style>



// WEBPACK FOOTER //
// PostOverview.vue?6ff310b2